import vMagazine from "./v-magazine.vue";

export default Vue => {
  Vue.component("v-magazine", vMagazine);
};
